<template>
  <div class="vehicle-group-dashboard-operation" v-loading="loading">
    <template>
      <NoService v-if="!loading && noService" />
      <template v-else>
        <AlertBox
          class="mb16"
          title="车辆运营看板每日上午9点更新T-1日的数据，可能由于网络波动产生1小时左右延迟"
          btnText="刷新数据"
          @btnClick="update"
        />

        <FiltersBox
          class="mb16"
          :filterList="globalFilter.filterList"
          :model.sync="globalFilter.model"
          @change="handleGlobalFiltersChange"
        />

        <div class="module-title">数据大盘</div>

        <el-row class="mb16" :gutter="16">
          <el-col :span="12">
            <!-- 网约注册情况 -->
            <HorizontalCardStyle2
              :title="registerData.title"
              :dataDesc="registerData.dataDesc"
              :dataUpdateTime="registerData.dataUpdateTime"
              :primaryDataList="registerData.primaryDataList"
              :secondaryDataList="registerData.secondaryDataList"
            />
          </el-col>
           <el-col :span="12">
            <!-- 网约出车情况 -->
            <HorizontalCardStyle2
              :title="workData.title"
              :dataDesc="workData.dataDesc"
              :dataUpdateTime="workData.dataUpdateTime"
              :btnText="workData.btnText"
              :primaryDataList="workData.primaryDataList"
              :secondaryDataList="workData.secondaryDataList"
              @btnClick="handleViewWorkImpactFactors"
            />
          </el-col>
        </el-row>

        <el-row class="mb16" :gutter="16">
          <el-col :span="12">
            <!-- 网约运营情况 -->
            <HorizontalCardStyle2
              :title="gmvData.title"
              :dataDesc="gmvData.dataDesc"
              :dataUpdateTime="gmvData.dataUpdateTime"
              :btnText="gmvData.btnText"
              :primaryDataList="gmvData.primaryDataList"
              :secondaryDataList="gmvData.secondaryDataList"
              @btnClick="handleViewOperateImpactFactors"
            />
          </el-col>
        </el-row>

        <FiltersBox
          class="mb16"
          :filterList="chartFilter.filterList"
          :model.sync="chartFilter.model"
          @change="handleChartFiltersChange"
        />

        <el-row class="mb16" :gutter="16">
          <el-col :span="12">
            <!-- 网约注册率（折线图） -->
            <LineChartCard
              class="chart"
              :title="registerChartData.title"
              :tooltip="registerChartData.tooltip"
              :dataDesc="registerChartData.dataDesc"
              :dataUpdateTime="registerChartData.dataUpdateTime"
              :xAxis="registerChartData.xAxis"
              :yAxis="registerChartData.yAxis"
              :legendData="registerChartData.legendData"
              :seriesData="registerChartData.seriesData"
              :unit="registerChartData.unit"
            />
          </el-col>
          <el-col :span="12">
            <!-- 网约出车率（折线图） -->
            <LineChartCard
              class="chart"
              :title="workChartData.title"
              :tooltip="workChartData.tooltip"
              :dataDesc="workChartData.dataDesc"
              :dataUpdateTime="workChartData.dataUpdateTime"
              :xAxis="workChartData.xAxis"
              :yAxis="workChartData.yAxis"
              :legendData="workChartData.legendData"
              :seriesData="workChartData.seriesData"
              :unit="workChartData.unit"
            />
          </el-col>
        </el-row>

        <el-row class="mb16" :gutter="16">
          <el-col :span="12">
            <!-- 网约GMV（折线图） -->
            <LineChartCard
              class="chart"
              :title="gmvChartData.title"
              :tooltip="gmvChartData.tooltip"
              :dataDesc="gmvChartData.dataDesc"
              :dataUpdateTime="gmvChartData.dataUpdateTime"
              :xAxis="gmvChartData.xAxis"
              :yAxis="gmvChartData.yAxis"
              :legendData="gmvChartData.legendData"
              :seriesData="gmvChartData.seriesData"
              :unit="gmvChartData.unit"
            />
          </el-col>
        </el-row>
      </template>
    </template>
  </div>
</template>
<script>
import moment from 'moment'
import AlertBox from '@/bizComponents/Dashboard/alertBox/index.vue'
import NoService from '@/bizComponents/Dashboard/noService/index.vue'
import FiltersBox from '@/bizComponents/Dashboard/filtersBox/index.vue'
import HorizontalCardStyle2 from '@/bizComponents/Dashboard/cards/horizontalCard/style2.vue'
import LineChartCard from '@/bizComponents/Dashboard/cards/lineChartCard/index.vue'
import { getYAxisPercentMax, getYAxisPercentMin, getYAxisNumMax, getYAxisNumMin } from '@/bizComponents/Dashboard/utils/function'
import { getShareList } from '@/api/domain/organize'
import { getVehicleOperateSummaryInfo, getVehicleOperateChartInfo } from '@/api/domain/vehicle'
import { convertNumber } from '@/utils/'

const formateSpIdOptions = (options) => {
  options.forEach((option) => {
    option.label = option.name || ''
    option.value = option.id || ''
  })
  return options
}

export default {
  components: {
    AlertBox,
    NoService,
    FiltersBox,
    HorizontalCardStyle2,
    LineChartCard,
  },
  provide() {
    return {
      ratioConfig: this.globalFilter.model,
    }
  },
  data() {
    return {
      // 全局筛选
      globalFilter: {
        filterList: [
          {
            type: 'select',
            label: '所属网约平台',
            name: 'spId',
            options: [],
          },
          {
            type: 'select',
            label: '环比/同比',
            name: 'showRatio',
            options: [
              {
                label: '展示',
                value: true,
              },
              {
                label: '不展示',
                value: false,
              },
            ],
          },
        ],
        model: {
          spId: '',
          showRatio: true,
        },
      },
      // 局部筛选
      chartFilter: {
        filterList: [
          {
            type: 'dateRange',
            label: '时间',
            name: 'date',
            t_1: true,
            // 结束日期不可>当前日期，时间范围不可大于1年
            pickerOptions: {
              tipConfig: {
                type: 1,
                daysNum: 365,
              },
              disabledDate: (time) => {
                return time.getTime() >= new Date(moment().format('YYYY-MM-DD 00:00:00')).getTime()
              },
            },
          },
        ],
        model: {
          // 默认最近30天
          date: [
            moment(new Date(Date.now() - 24 * 60 * 60 * 1000 - (30 * 24 * 60 * 60 * 1000))).format('YYYY-MM-DD HH:mm:ss'),
            moment(new Date(Date.now() - 24 * 60 * 60 * 1000)).format('YYYY-MM-DD HH:mm:ss'),
          ],
        },
      },
      // 网约注册情况
      registerData: {
        title: '网约注册情况',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 网约出车情况
      workData: {
        title: '网约出车情况',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        btnText: '查看影响因子',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 网约运营情况
      gmvData: {
        title: '网约运营情况',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        btnText: '查看影响因子',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 网约注册率-图表
      registerChartData: {
        title: '网约注册率',
        tooltip: '网约注册率=截止指定日期在租车辆已完成网约平台注册的数量/指定日期在租车辆数',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        xAxis: {
          data: [],
        },
        yAxis: {
          axisLabel: {
            show: true,
            interval: 'auto',
            formatter: '{value}%',
          },
          max: (value) => getYAxisPercentMax(value, 10),
          min: (value) => getYAxisPercentMin(value, 10),
        },
        legendData: [],
        seriesData: [],
        unit: '%',
      },
      // 网约出车率-图表
      workChartData: {
        title: '网约出车率',
        tooltip: '网约出车率=∑（单车在时间范围内出车的总天数）/∑（单车在时间范围内处于已租状态且已注册网约的总天数）',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        xAxis: {
          data: [],
        },
        yAxis: {
          axisLabel: {
            show: true,
            interval: 'auto',
            formatter: '{value}%',
          },
          max: (value) => getYAxisPercentMax(value, 10),
          min: (value) => getYAxisPercentMin(value, 10),
        },
        legendData: [],
        seriesData: [],
        unit: '%',
      },
      // 网约GMV-图表
      gmvChartData: {
        title: '网约GMV',
        tooltip: 'GMV=∑（时间范围内出车的车辆行程费）',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        xAxis: {
          data: [],
        },
        yAxis: {
          axisLabel: {
            show: true,
            interval: 'auto',
            formatter: '{value}万元',
          },
          max: (value) => getYAxisNumMax(value, 5),
          min: (value) => getYAxisNumMin(value, 5),
        },
        legendData: [],
        seriesData: [],
        unit: '万元',
      },
      noService: true,
      loading: false,
      isCache: true,
    }
  },
  computed: {
    params() {
      const { date } = this.chartFilter.model
      const startDate = Array.isArray(date) ? moment(date[0]).format('YYYY-MM-DD') : ''
      const endDate = Array.isArray(date) ? moment(date[1]).format('YYYY-MM-DD') : ''
      return {
        spId: this.globalFilter.model.spId || '',
        startDate,
        endDate,
      }
    },
  },
  async created() {
    const shareList = await this.getShareList()
    if (shareList.length) {
      this.update()
    }
  },
  methods: {
    update() {
      this.loading = true
      Promise.all([
        this.getVehicleOperateSummaryInfo(),
        this.getVehicleOperateChartInfo(),
      ]).finally(() => {
        this.loading = false
      })
    },
    handleGlobalFiltersChange() {
      this.update()
    },
    handleChartFiltersChange() {
      this.getVehicleOperateChartInfo()
    },
    // 获取网约平台列表
    async getShareList() {
      this.loading = true

      let res

      try {
        res = await getShareList()
      } catch (err) {
        console.error(err)
      }
      this.loading = false

      if (!res) return

      const { code, data } = res

      if (code === 1 && Array.isArray(data) && data.length > 0) {
        this.noService = false
        // 选中第一个网约平台
        const spIdFilter = this.globalFilter.filterList.find((item) => item.name === 'spId')
        spIdFilter.options = formateSpIdOptions(data || [])
        this.globalFilter.model.spId = spIdFilter.options[0].id
      }

      return data || []
    },
    // 统计数据信息
    async getVehicleOperateSummaryInfo() {
      let res

      try {
        res = await getVehicleOperateSummaryInfo(this.params)
      } catch (err) {
        console.error(err)
      }

      if (!res) return

      const { code, data } = res

      if (code === 1) {
        this.registerData.dataUpdateTime = data?.updateTime || ''
        this.workData.dataUpdateTime = data?.updateTime || ''
        this.gmvData.dataUpdateTime = data?.updateTime || ''

        this.registerData.primaryDataList = [
          {
            label: '昨日网约注册率',
            value: ((data?.yesterdayNcRegisterRate?.value || 0) * 100).toFixed(2),
            unit: '%',
            tooltip: '昨日网约注册率=截止昨日在租车辆已完成网约平台注册的数量/昨日在租车辆',
            ratioList: [
              {
                name: '日环比',
                value: data?.yesterdayNcRegisterRate?.dayRadio,
              },
              {
                name: '周同比',
                value: data?.yesterdayNcRegisterRate?.weekYoY,
              },
            ],
          },
        ]

        this.workData.primaryDataList = [
          {
            label: '昨日网约出车率',
            value: ((data?.yesterdayNcWorkRate?.value || 0) * 100).toFixed(2),
            unit: '%',
            tooltip: '昨日网约出车率=∑（单车在昨日出车的总天数）/∑（单车在昨日处于已租状态且已注册网约的总天数）',
            ratioList: [
              {
                name: '日环比',
                value: data?.yesterdayNcWorkRate?.dayRadio,
              },
              {
                name: '周同比',
                value: data?.yesterdayNcWorkRate?.weekYoY,
              },
            ],
          },
          {
            label: '本周网约出车率',
            value: ((data?.weekNcWorkRate?.value || 0) * 100).toFixed(2),
            unit: '%',
            tooltip: '本周网约出车率=∑（单车在本周内出车的总天数）/∑（单车在本周内处于已租状态且已注册网约的总天数）',
            ratioList: [
              // {
              //   name: '周环比',
              //   value: data?.weekNcWorkRate?.weekYoY
              // }
            ],
          },
          {
            label: '本月网约出车率',
            value: ((data?.monthNcWorkRate?.value || 0) * 100).toFixed(2),
            unit: '%',
            tooltip: '本月网约出车率=∑（单车在本月内出车的总天数）/∑（单车在本月处于已租状态且已注册网约的总天数）',
            ratioList: [
              // {
              //   name: '月环比',
              //   value: data?.monthNcWorkRate?.monthYoY
              // }
            ],
          },
        ]

        this.gmvData.primaryDataList = [
          {
            label: '昨日网约运营总金额',
            value: convertNumber((data?.yesterdayNcGMV?.value || 0) / 10000),
            valueTooltip: `${convertNumber(data?.yesterdayNcGMV?.value || 0)}元`,
            unit: '万元',
            tooltip: '昨日网约运营总金额=∑（昨日出车的车辆行程费）',
            ratioList: [
              {
                name: '日环比',
                value: data?.yesterdayNcGMV?.dayRadio,
              },
              {
                name: '周同比',
                value: data?.yesterdayNcGMV?.weekYoY,
              },
            ],
          },
          {
            label: '本周网约运营总金额',
            value: convertNumber((data?.weekNcGMV?.value || 0) / 10000),
            valueTooltip: `${convertNumber(data?.weekNcGMV?.value || 0)}元`,
            unit: '万元',
            tooltip: '本周网约运营总金额=∑（本周出车的车辆行程费）',
            ratioList: [
              // {
              //   name: '周环比',
              //   value: data?.weekNcGMV?.weekYoY
              // }
            ],
          },
          {
            label: '本月网约运营总金额',
            value: convertNumber((data?.monthNcGMV?.value || 0) / 10000),
            valueTooltip: `${convertNumber(data?.monthNcGMV?.value || 0)}元`,
            unit: '万元',
            tooltip: '本月网约运营总金额=∑（本月出车的车辆行程费）',
            ratioList: [
              // {
              //   name: '月环比',
              //   value: data?.monthNcGMV?.monthYoY
              // }
            ],
          },
        ]
      }
    },
    // 图表
    async getVehicleOperateChartInfo() {
      let res

      try {
        res = await getVehicleOperateChartInfo({
          ...this.params,
          isCache: this.isCache,
        })
      } catch (err) {
        console.error(err)
      }

      if (this.isCache) {
        this.isCache = !this.isCache
      }

      if (!res) return

      const { code, data } = res

      if (code === 1) {
        const registerDataList = data?.ncRegisterRate?.dataList || []
        const workDataList = data?.ncWorkRate?.dataList || []
        const gmvDataList = data?.ncGMV?.dataList || []

        this.registerChartData.dataUpdateTime = data?.updateTime || ''
        this.workChartData.dataUpdateTime = data?.updateTime || ''
        this.gmvChartData.dataUpdateTime = data?.updateTime || ''

        // 网约注册率
        // 图例
        this.registerChartData.legendData = data?.ncRegisterRate?.nameList || []
        this.registerChartData.xAxis.data = registerDataList.map((item) => item.ds) || []
        // 系列
        this.registerChartData.seriesData = this.registerChartData.legendData.map((item) => {
          return {
            // 系列名称
            name: item,
            data: registerDataList.map((itm) => {
              const deptInfo = itm.deptList.find((dept) => dept.deptName === item)
              // X轴数据
              const date = itm.ds
              // Y轴数据
              const value = ((deptInfo?.value || 0) * 100).toFixed(2)
              // 数据名称
              const dataTitle = this.registerChartData.title
              // 环比/同比
              const dayRadio = (deptInfo?.dayRadio) || 0
              const weekRadio = (deptInfo?.weekYoY) || 0
              return [
                date,
                value,
                {
                  dataTitle,
                  ratioList: [
                    {
                      name: '日环比',
                      value: dayRadio,
                    },
                    {
                      name: '周同比',
                      value: weekRadio,
                    },
                  ],
                },
              ]
            }),
          }
        })

        // 网约出车率
        // 图例
        this.workChartData.legendData = data?.ncWorkRate?.nameList || []
        this.workChartData.xAxis.data = workDataList.map((item) => item.ds) || []
        // 系列
        this.workChartData.seriesData = this.workChartData.legendData.map((item) => {
          return {
            // 系列名称
            name: item,
            data: workDataList.map((itm) => {
              const deptInfoItem = itm.deptList.find((deptInfo) => deptInfo.deptName === item)
              // X轴数据
              const date = itm.ds
              // Y轴数据
              const value = ((deptInfoItem?.value || 0) * 100).toFixed(2)
              // 数据名称
              const dataTitle = this.workChartData.title
              // 环比/同比
              const dayRadio = (deptInfoItem?.dayRadio) || 0
              const weekRadio = (deptInfoItem?.weekYoY) || 0
              return [
                date,
                value,
                {
                  dataTitle,
                  ratioList: [
                    {
                      name: '日环比',
                      value: dayRadio,
                    },
                    {
                      name: '周同比',
                      value: weekRadio,
                    },
                  ],
                },
              ]
            }),
          }
        })

        // 网约GMV
        // 图例
        this.gmvChartData.legendData = data?.ncGMV?.nameList || []
        this.gmvChartData.xAxis.data = gmvDataList.map((item) => item.ds) || []
        // 系列
        this.gmvChartData.seriesData = this.gmvChartData.legendData.map((item) => {
          return {
            // 系列名称
            name: item,
            data: gmvDataList.map((itm) => {
              const deptInfoItem = itm.deptList.find((deptInfo) => deptInfo.deptName === item)
              // X轴数据
              const date = itm.ds
              // Y轴数据
              const value = convertNumber((deptInfoItem?.value || 0) / 10000)
              // 数据名称
              const dataTitle = this.gmvChartData.title
              // 环比/同比
              const dayRadio = (deptInfoItem?.dayRadio) || 0
              const weekRadio = (deptInfoItem?.weekYoY) || 0
              return [
                date,
                value,
                {
                  dataTitle,
                  ratioList: [
                    {
                      name: '日环比',
                      value: dayRadio,
                    },
                    {
                      name: '周同比',
                      value: weekRadio,
                    },
                  ],
                },
              ]
            }),
          }
        })
      }
    },
    // 网约出车情况-查看影响因子
    handleViewWorkImpactFactors() {
      const { spId } = this.globalFilter.model

      this.$router.push({
        path: '/vehicle/linkage/workImpactFactor/detail',
        query: {
          spId,
        },
      })
    },
    // 网约运营情况-查看影响因子
    handleViewOperateImpactFactors() {
      const { spId } = this.globalFilter.model

      this.$router.push({
        path: '/vehicle/linkage/operateImpactFactor/detail',
        query: {
          spId,
        },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.mb16 {
  margin-bottom: 16px;
}
.mt24 {
  margin-top: 24px;
}
.module-title {
  margin-top: 24px;
  margin-bottom: 16px;
  font-size: 20px;
  font-weight: 600;
  line-height: 22px;
  color: #3D3D3D;
}
</style>
